export enum FederatedIdentityProviderEnum {
  AZURE_AD = 'azure-ad',
  GOOGLE = 'google',
}
export default interface FederatedDomain {
  id: string;
  domain: string;
  identityProvider: FederatedIdentityProviderEnum;
}
